import React from 'react'

import IAgreementRowData from './agreement-row.interface'

const Agreement: React.FC<IAgreementRowData> = ({ data, thisYearsData, setThisYearsData }) => {
  const handleNewData = (value: number) => {
    if (thisYearsData && setThisYearsData) {
      const thisYearsDataClone = Object.assign({}, thisYearsData)
      let index = thisYearsDataClone.data.findIndex(
        (element) => element.collectiveAgreement === data.collectiveAgreement,
      )
      if (index === -1) {
        thisYearsDataClone.data.push(data)
        index = thisYearsDataClone.data.findIndex(
          (element) => element.collectiveAgreement === data.collectiveAgreement,
        )
      }
      thisYearsDataClone.data[index].numEmployees = value
      setThisYearsData(thisYearsDataClone)
    }
  }

  if (!data) {
    return null
  }

  return thisYearsData ? (
        <div className="flex flex-col gap-4">
          <p className="label">{data.collectiveAgreementLabel}</p>
          <div className="flex flex-row gap-8">
            <div className="w-full">
              <input
                className="input "
                defaultValue={data.numEmployees.toString()}
                onChange={(e) => handleNewData(parseInt(e.target.value, 10))}
                type="number"
              />
            </div>

              <div className="last-year-box">
                <p className="font-bold">{data.prevNumEmployees}</p>
              </div>
    
          </div>
        </div>
      ) : (
        <tr className="tbody-tr">
          <td className="td w-1/2">
            <p className="w-full table-text">{data.collectiveAgreementLabel}</p>
          </td>
          <td className="td w-1/2">
            <p className="w-full table-text">{data.numEmployees}</p>
          </td>
        </tr>
      )
}

export default Agreement
